export default "__VITE_ASSET__VB6DFPPg__"